import { render, staticRenderFns } from "./AtalanyCard.vue?vue&type=template&id=1ac7bf7d&scoped=true"
import script from "./AtalanyCard.vue?vue&type=script&lang=js"
export * from "./AtalanyCard.vue?vue&type=script&lang=js"
import style0 from "./AtalanyCard.vue?vue&type=style&index=0&id=1ac7bf7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac7bf7d",
  null
  
)

export default component.exports